<template>
    <div class="main-content">

        <!-- 条件查询 -->
        <div >
            <el-form :inline="true" :model="searchForm" class="form-content">
                <el-row :gutter="20" class="slt" :style="{justifyContent:contents.searchBoxPosition=='1'?'flex-start':contents.searchBoxPosition=='2'?'center':'flex-end'}">

                    <el-form-item label="支付方式">
                        <el-select v-model="searchForm.payType" placeholder="请选择支付方式" clearable>
                            <el-option label="支付宝" value="ZFB"></el-option>
                            <el-option label="微信" value="WX"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="search()">查询<i class="el-icon-search el-icon--right"/></el-button>
                    </el-form-item>
                </el-row>
                
            </el-form>
            <div class="table-content">
                <el-table class="tables" :size="contents.tableSize" :show-header="contents.tableShowHeader"
                          :header-row-style="headerRowStyle" :header-cell-style="headerCellStyle"
                          :border="contents.tableBorder"
                          :fit="contents.tableFit"
                          :stripe="contents.tableStripe"
                          :row-style="rowStyle"
                          :cell-style="cellStyle"
                          :style="{width: '100%',fontSize:contents.tableContentFontSize,color:contents.tableContentFontColor}"
                          :data="dataList"
                          v-loading="dataListLoading"
                          @selection-change="selectionChangeHandler">
                    <el-table-column label="索引" v-if="contents.tableIndex" type="index" width="50" />

                    <el-table-column  align = "center"   prop="userName"   header-align="center"  label="用户名"></el-table-column>
                    <el-table-column  align = "center"   prop="userMoblile"   header-align="center"  label="联系方式"></el-table-column>
                    <el-table-column  align = "center"   prop="payType"   header-align="center"  label="支付方式">
                        <template slot-scope="scope">
                            <span >{{ scope.row.payType === 'ZFB' ? '支付宝' : '微信' }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column  align = "center"   prop="payNo"   header-align="center"  label="订单号"></el-table-column>
                    <el-table-column  align = "center"   prop="payAmount"   header-align="center"  label="支付金额"></el-table-column>
                    <el-table-column  align = "center" prop="payTime"   header-align="center"    label="支付时间">
                        <template slot-scope="scope">
                            <span >{{formatDate(scope.row.payTime)}}</span>
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination
                        clsss="pages"
                        :layout="layouts"
                        @size-change="sizeChangeHandle"
                        @current-change="currentChangeHandle"
                        :current-page="pageIndex"
                        :page-sizes="[10, 20, 50, 100]"
                        :page-size="Number(contents.pageEachNum)"
                        :total="totalPage"
                        :small="contents.pageStyle"
                        class="pagination-content"
                        :background="contents.pageBtnBG"
                        :style="{textAlign:contents.pagePosition==1?'left':contents.pagePosition==2?'center':'right'}"
                ></el-pagination>

            </div>
        </div>
    </div>
</template>
<script>
    import styleJs from "../../../utils/style.js";

    export default {
        data() {
            return {
                searchForm: {
                    payType: "",
                    key: ""
                },
                sessionTable : "",//登录账户所在表名
                role : "",//权限
                userId:"",//当前登录人的id
                //级联表下拉框搜索条件
                //当前表下拉框搜索条件
                dataList: [],
                pageIndex: 1,
                pageSize: 10,
                totalPage: 0,
                dataListLoading: false,
                dataListSelections: [],
                contents:null,
                layouts: '',
                rowData: {},
                selectBtnStr:'',
                menuBtnList:[],
            };
        },
        created() {
            this.contents = styleJs.listStyle();
            this.init();
            this.getDataList();

        },
        mounted() {
            //获取当前登录用户的信息
            this.sessionTable = this.$storage.get("sessionTable");
            this.role = this.$storage.get("role");
            this.userId = this.$storage.get("userId");

        },
        filters: {
            htmlfilter: function (val) {
                return val.replace(/<[^>]*>/g).replace(/undefined/g,'');
            }
        },
        computed: {
        },
        methods: {
            contentStyleChange() {
                this.contentSearchStyleChange()
                this.contentBtnAdAllStyleChange()
                this.contentSearchBtnStyleChange()
                this.contentTableBtnStyleChange()
                this.contentPageStyleChange()
            },
            contentSearchStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .slt .el-input__inner').forEach(el => {
                        let textAlign = 'left'
                        if(this.contents.inputFontPosition == 2)
                        textAlign = 'center'
                        if (this.contents.inputFontPosition == 3) textAlign = 'right'
                        el.style.textAlign = textAlign
                        el.style.height = this.contents.inputHeight
                        el.style.lineHeight = this.contents.inputHeight
                        el.style.color = this.contents.inputFontColor
                        el.style.fontSize = this.contents.inputFontSize
                        el.style.borderWidth = this.contents.inputBorderWidth
                        el.style.borderStyle = this.contents.inputBorderStyle
                        el.style.borderColor = this.contents.inputBorderColor
                        el.style.borderRadius = this.contents.inputBorderRadius
                        el.style.backgroundColor = this.contents.inputBgColor
                    })
                    if (this.contents.inputpayType) {
                        document.querySelectorAll('.form-content .slt .el-form-item__label').forEach(el => {
                            el.style.color = this.contents.inputpayTypeColor
                            el.style.fontSize = this.contents.inputpayTypeSize
                            el.style.lineHeight = this.contents.inputHeight
                        })
                    }
                    setTimeout(() => {
                        document.querySelectorAll('.form-content .slt .el-input__prefix').forEach(el => {
                            el.style.color = this.contents.inputIconColor
                            el.style.lineHeight = this.contents.inputHeight
                        })
                        document.querySelectorAll('.form-content .slt .el-input__suffix').forEach(el => {
                            el.style.color = this.contents.inputIconColor
                            el.style.lineHeight = this.contents.inputHeight
                        })
                        document.querySelectorAll('.form-content .slt .el-input__icon').forEach(el => {
                            el.style.lineHeight = this.contents.inputHeight
                        })
                    }, 10 )
                })
            },
            // 搜索按钮
            contentSearchBtnStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .slt .el-button--success').forEach(el => {
                        el.style.height = this.contents.searchBtnHeight
                        el.style.color = this.contents.searchBtnFontColor
                        el.style.fontSize = this.contents.searchBtnFontSize
                        el.style.borderWidth = this.contents.searchBtnBorderWidth
                        el.style.borderStyle = this.contents.searchBtnBorderStyle
                        el.style.borderColor = this.contents.searchBtnBorderColor
                        el.style.borderRadius = this.contents.searchBtnBorderRadius
                        el.style.backgroundColor = this.contents.searchBtnBgColor
                    })
                })
            },
            // 新增、批量删除
            contentBtnAdAllStyleChange() {
                this.$nextTick(() => {
                    document.querySelectorAll('.form-content .ad .el-button--success').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllAddFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllAddBgColor
                    })
                    document.querySelectorAll('.form-content .ad .el-button--danger').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllDelFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllDelBgColor
                    })
                    document.querySelectorAll('.form-content .ad .el-button--warning').forEach(el => {
                        el.style.height = this.contents.btnAdAllHeight
                        el.style.color = this.contents.btnAdAllWarnFontColor
                        el.style.fontSize = this.contents.btnAdAllFontSize
                        el.style.borderWidth = this.contents.btnAdAllBorderWidth
                        el.style.borderStyle = this.contents.btnAdAllBorderStyle
                        el.style.borderColor = this.contents.btnAdAllBorderColor
                        el.style.borderRadius = this.contents.btnAdAllBorderRadius
                        el.style.backgroundColor = this.contents.btnAdAllWarnBgColor
                    })
                })
            },
            // 表格
            rowStyle({row, rowIndex}) {
                if (rowIndex % 2 == 1) {
                    if (this.contents.tableStripe) {
                        return {color: this.contents.tableStripeFontColor}
                    }
                } else {
                    return ''
                }
            },
            cellStyle({row, rowIndex}) {
                if (rowIndex % 2 == 1) {
                    if (this.contents.tableStripe) {
                        return {backgroundColor: this.contents.tableStripeBgColor}
                    }
                } else {
                    return ''
                }
            },
            headerRowStyle({row, rowIndex}) {
                return {color: this.contents.tableHeaderFontColor}
            },
            headerCellStyle({row, rowIndex}) {
                return {backgroundColor: this.contents.tableHeaderBgColor}
            },
            // 表格按钮
            contentTableBtnStyleChange() {
            },
            // 分页
            contentPageStyleChange() {
                let arr = []
                if (this.contents.pageTotal) arr.push('total')
                if (this.contents.pageSizes) arr.push('sizes')
                if (this.contents.pagePrevNext) {
                    arr.push('prev')
                    if (this.contents.pagePager) arr.push('pager')
                    arr.push('next')
                }
                if (this.contents.pageJumper) arr.push('jumper')
                this.layouts = arr.join()
                this.contents.pageEachNum = 10
            },

            init() {
            },
            search() {
                this.pageIndex = 1;
                this.getDataList();
            },
            // 获取数据列表
            getDataList() {
                this.dataListLoading = true;
                let params = {
                    page: this.pageIndex,
                    limit: this.pageSize,
                    sort: 'id',
                    order: 'desc'
                }
                if (this.searchForm.payType!== '' && this.searchForm.payType!== undefined) {
                    params['payType'] = this.searchForm.payType
                }

                this.$http({
                    url: "payRecords/page",
                    method: "get",
                    params: params
                }).then(({data}) => {
                    if(data && data.code === 0){
                        this.dataList = data.data.list;
                        this.totalPage = data.data.total;
                    }else{
                        this.dataList = [];
                        this.totalPage = 0;
                    }
                    this.dataListLoading = false;
                });

                //查询级联表搜索条件所有列表
                //查询当前表搜索条件所有列表
            },
            //每页数
            sizeChangeHandle(val) {
                this.pageSize = val;
                this.pageIndex = 1;
                this.getDataList();
            },
            // 当前页
            currentChangeHandle(val) {
                this.pageIndex = val;
                this.getDataList();
            },
            // 多选
            selectionChangeHandler(val) {
                this.dataListSelections = val;
            },
            formatDate(dateStr){
                let date = new Date(dateStr);
                return date.toLocaleString();
            },
        }
    };
</script>
<style lang="scss" scoped>
    .main-content {
        background: #fff;
        border-radius: 6px;
        padding: 20px;
        box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
    }

    .slt {
        margin: 0 !important;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        gap: 0;
        padding-bottom: 12px;
        border-bottom: 1px solid #f0f0f0;
    }

    .ad {
        margin: 0 !important;
        display: flex;
        align-items: center;
        padding: 12px 0;
    }

    .pages {
        & /deep/ el-pagination__sizes {
            & /deep/ el-input__inner {
                height: 28px;
                line-height: 28px;
            }
        }
    }

    .el-button+.el-button {
        margin-left: 8px;
    }

    .form-content {
        background: transparent;
    }

    .table-content {
        background: transparent;
    }

    /* 搜索区按钮 */
    .form-content .slt .el-button--success {
        background-color: var(--publicMainColor);
        border-color: var(--publicMainColor);
        color: #fff;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        transition: all 0.25s ease;

        &:hover {
            background-color: #2b5797;
            border-color: #2b5797;
        }
    }

    /* 新增按钮 */
    .form-content .ad .el-button--success {
        background-color: var(--publicSubColor);
        border-color: var(--publicSubColor);
        color: #fff;
        border-radius: 4px;
        padding: 10px 20px;
        font-size: 14px;
        transition: all 0.25s ease;

        &:hover {
            background-color: #c9602d;
            border-color: #c9602d;
        }
    }

    /* 表格样式 */
    .tables {
        width: 100%;
        border-radius: 4px;
        overflow: hidden;

        & /deep/ .el-table__header th {
            background-color: #f5f7fa;
            color: #303133;
            font-weight: 600;
            font-size: 14px;
        }

        & /deep/ .el-table__body tr {
            background-color: #fff !important;
            color: #606266 !important;
        }

        & /deep/ .el-table__body tr.el-table__row--striped td {
            background: #fafafa;
        }

        & /deep/ .el-table__body tr.el-table__row--striped {
            background-color: #fafafa !important;
            color: #606266 !important;
        }

        & /deep/ .el-table__body tr:hover > td {
            background-color: rgba(58, 110, 165, 0.06) !important;
            color: #303133 !important;
        }

        /* 表格操作按钮 */
        & /deep/ .el-button--success {
            background-color: #67c23a;
            border-color: #67c23a;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #85ce61;
                border-color: #85ce61;
            }
        }

        & /deep/ .el-button--primary {
            background-color: var(--publicMainColor);
            border-color: var(--publicMainColor);
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #2b5797;
                border-color: #2b5797;
            }
        }

        & /deep/ .el-button--danger {
            background-color: #f56c6c;
            border-color: #f56c6c;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #f78989;
                border-color: #f78989;
            }
        }

        & /deep/ .el-button--warning {
            background-color: #e6a23c;
            border-color: #e6a23c;
            color: #fff;
            border-radius: 4px;
            padding: 7px 15px;
            font-size: 12px;
            border-style: solid;
            border-width: 1px;

            &:hover {
                background-color: #ebb563;
                border-color: #ebb563;
            }
        }

        & /deep/ .el-button {
            margin: 4px;
        }
    }

    /* 分页 */
    .pagination-content {
        margin-top: 20px;
        padding: 10px 0;
    }

    /* 封面图片 */
    .tables /deep/ img {
        border-radius: 6px;
        object-fit: cover;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
    }
</style>


